var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eligibleForPlanAhead)?_c('navigation-menu-item',{attrs:{"title":"התוכניות שלי","target":"plan-ahead","icon-name":"target"},on:{"navigate":function($event){return _vm.$emit('navigate')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }